import { groupBy } from 'features/shared/helpers/Arrays';
import React from 'react';
import BillingDetailDTO from 'features/billings/dtos/BillingDetailDTO';
import BillingArea from './BillingArea';

interface Props {
  billingDetails: BillingDetailDTO[];
  periodFrom: Date;
  periodTo: Date;
}

const BillingAreaList = ({ billingDetails, periodFrom, periodTo }: Props) => {
  // sub-renders
  const renderBillingAreas = (): JSX.Element[] => {
    let result:JSX.Element[] = [];

    const areas = groupBy<BillingDetailDTO>(billingDetails, "billingArea");
    const iterableAreas = Object.entries(areas);
    
    for (let i = 0; i < iterableAreas.length; i++) {
      const [areaCode, area] = iterableAreas[i];
      const areaElem = (
        <BillingArea
          title={areaCode}
          billingDetails={area}
          periodFrom={periodFrom!}
          periodTo={periodTo!}
          key={i}
        />
      );

      result.push(areaElem);
    }

    return result;
  }

  // render
  return (
    <>
      {renderBillingAreas()}
    </>
  )
}

export default BillingAreaList;
